// extracted by mini-css-extract-plugin
module.exports = {"note":"NoteAnother_note__fpWXu"};